/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Center,
  Button as ChakraButton,
  Checkbox,
  CircularProgress,
  HStack,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  Tooltip,
  useDisclosure,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { sendBookAsEmail } from '@partiu/api/bookstore/api';
import {
  useDownloadMutation,
  useFavoriteBookMutation,
  useGetBookReadingMutation,
  useUnFavoriteBookMutation,
} from '@partiu/api/bookstore/hooks';
import { useAPICallAsMutation } from '@partiu/api/hooks';
import { useEffect, useRef, useState } from 'react';
import { FaDownload, FaEnvelope, FaHeart } from 'react-icons/fa';
import { LuMoveRight } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import { Input } from '../../../../../packages/ui/components/atoms/Input';
import { SectionTitle } from '../../../../../packages/ui/components/atoms/Title';
import { useProfile } from '../../../../../packages/ui/contexts/ProfileProvider';
import { useTheme } from '../../../../../packages/ui/contexts/ThemeProvider';
import { downloadFile } from '../../../../../packages/ui/utils';
import { useOpenBook } from '../../contexts/BookContext';
import { FaArrowRotateRight } from 'react-icons/fa6';
import AudioBookPlayer from './AudioBookPlayer';
import { APP_EVENTS, spawnAppEvent } from '../../../../../packages/ui/mobileEvents';

export function BookModal() {
  const { onOpen, onClose, isOpen } = useDisclosure();

  const openAudio = useDisclosure();

  const { onOpen: downloadOnOpen, onClose: donwloadOnClose, isOpen: downloadIsOpen } = useDisclosure();
  const toast = useToast();
  const cancelRef = useRef<HTMLButtonElement>(null);
  const { id, uraModuleCellphone, colors, isNative, bookstoreTypes, isApp } = useTheme();
  const { profile } = useProfile();
  const { book, isReceivedBook, closeBook } = useOpenBook();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [favorite, setFavorite] = useState(book?.isFavorite || false);
  const [agreed, setAgreed] = useState(false);

  const isAudioBook = book?.type === 'audiobook';

  const canDowload = isReceivedBook ? true : false;

  useEffect(() => {
    setFavorite(book?.isFavorite || false);
  }, [book]);

  useEffect(() => {
    if (profile) setEmail(profile.email);
  }, [profile]);

  const navigateTo = (url: string, params?: any) => {
    navigate(`${url}${isNative ? '?isNative=true' : ''}`, params);
  };

  const sendBookAsEmailMutation = useAPICallAsMutation(sendBookAsEmail, {
    onSuccess() {
      onClose();
      toast({ title: 'Sucesso!', description: 'Em instantes o livro será enviado para seu email.', status: 'success' });
    },
    onError() {
      if (!profile) return;
      navigateTo(`/perfil/planos/purchase-subscription-mobile/${btoa(profile.cpf + ':' + id)}`);
      toast({
        title: 'Compre recorrente Já!',
        description: 'Para ler este livro, é necessario uma assinatura.',
        status: 'error',
      });
    },
  });

  const unfavoriteBook = useUnFavoriteBookMutation({
    onSuccess() {
      setFavorite(false);
    },
    onError(error: any) {
      console.log(error);
    },
  });

  const favoriteBook = useFavoriteBookMutation({
    onSuccess() {
      setFavorite(true);
    },
    onError(error: any) {
      console.log(error);
    },
  });

  const downloadBook = useDownloadMutation({
    onSuccess(payload: any) {
      const file_url = payload?.file_url;
      if (isApp) {
        spawnAppEvent(APP_EVENTS.OPEN_LINK, file_url);
      } else {
        const fileName = book?.title || book?.name || 'book';

        const fileExtension = bookstoreTypes.includes('magazine') ? 'pdf' : 'epub';

        downloadFile(`${fileName}.${fileExtension}`, file_url);
      }
    },
    onError(error: any) {
      console.log(error);
    },
  });

  const getBookMutation = useGetBookReadingMutation({
    onSuccess() {
      if (book?.type === 'book') {
        navigateTo(`/leitura/${book?.id}`);
      } else if (book?.type === 'magazine') {
        navigateTo(`/pdf/${book?.id}`);
      }
    },
    onError(error: any) {
      if (!profile) return;

      if (error?.response?.data?.book && error?.response?.data?.book[0] === 'Is not subscribed.') {
        navigateTo(`/perfil/planos/purchase-subscription-mobile/${btoa(profile.cpf + ':' + id)}`);
        toast({
          title: 'Compre recorrente Já!',
          description: 'Para ler este livro, é necessario uma assinatura.',
          status: 'error',
        });
        return;
      } else {
        toast({ title: 'Erro ao abrir o livro', description: 'Tente novamente mais tarde', status: 'error' });
      }
    },
  });

  return (
    <>
      <AlertDialog
        size={{ base: 'xs', sm: 'md', md: 'lg' }}
        leastDestructiveRef={cancelRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Enviar para qual email?
            </AlertDialogHeader>

            <AlertDialogBody>
              <VStack spacing={5} width={'100%'} align={'flex-start'}>
                <Text maxH={{ base: '40vh', sm: '40vh', md: '40vh', lg: '40vh' }} overflowY={'auto'}>
                  Nota:{' '}
                  {bookstoreTypes.includes('magazine') ? 'Esta revista foi adquirida' : 'Este livro foi adquirido'} de
                  forma legal e legítima, mas sua utilização é limitada ao uso pessoal do comprador, nos termos da Lei
                  nº 9.610/1998.
                  <br />
                  <br />
                  Qualquer reprodução, distribuição, compartilhamento, ou disponibilização do conteúdo a terceiros, sem
                  autorização expressa da editora ou do autor, constitui violação grave da lei de direitos autorais.
                  <br />
                  <br /> O descumprimento implicará em responsabilização criminal, conforme art. 184 do Código Penal,
                  com pena de reclusão de até 4 anos e multa, além de responsabilização civil com condenação ao
                  pagamento de danos morais e materiais.
                  <br />
                  <br /> Os titulares controlam e monitoram o uso indevido de suas obras, adotam medidas imediatas caso
                  identificada qualquer violação.
                  <br />
                  <br />
                  Preserve a legalidade e respeite os direitos dos autores e editoras.
                </Text>
                <Checkbox isChecked={agreed} onChange={(e) => setAgreed(e.target.checked)}>
                  Estou ciente e de acordo.
                </Checkbox>

                <Input value={email} onChange={(e) => setEmail(e.target.value)} label="Email de envio" />
              </VStack>
            </AlertDialogBody>

            <AlertDialogFooter>
              <ChakraButton variant={'ghost'} ref={cancelRef} onClick={onClose}>
                Cancelar
              </ChakraButton>
              <ChakraButton
                colorScheme="green"
                isDisabled={!agreed}
                onClick={() =>
                  book && id && sendBookAsEmailMutation.mutate({ bookID: book.id, email, agreement: id.toString() })
                }
                ml={3}
                isLoading={sendBookAsEmailMutation.isLoading}
              >
                Enviar
              </ChakraButton>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <AlertDialog
        size={{ base: 'xs', sm: 'md', md: 'lg' }}
        leastDestructiveRef={cancelRef}
        isOpen={downloadIsOpen}
        onClose={donwloadOnClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Fazer o download deste livro?
            </AlertDialogHeader>

            <AlertDialogBody>
              <VStack spacing={5} width={'100%'} align={'flex-start'}>
                <Text maxH={{ base: '50vh', sm: '50vh', md: '50vh', lg: '50vh' }} overflowY={'auto'}>
                  Nota: Este livro foi adquirido de forma legal e legítima, mas sua utilização é limitada ao uso pessoal
                  do comprador, nos termos da Lei nº 9.610/1998.
                  <br />
                  <br />
                  Qualquer reprodução, distribuição, compartilhamento, ou disponibilização do conteúdo a terceiros, sem
                  autorização expressa da editora ou do autor, constitui violação grave da lei de direitos autorais.
                  <br />
                  <br /> O descumprimento implicará em responsabilização criminal, conforme art. 184 do Código Penal,
                  com pena de reclusão de até 4 anos e multa, além de responsabilização civil com condenação ao
                  pagamento de danos morais e materiais.
                  <br />
                  <br /> Os titulares controlam e monitoram o uso indevido de suas obras, adotam medidas imediatas caso
                  identificada qualquer violação.
                  <br />
                  <br />
                  Preserve a legalidade e respeite os direitos dos autores e editoras.
                </Text>
                <Checkbox isChecked={agreed} onChange={(e) => setAgreed(e.target.checked)}>
                  Estou ciente e de acordo.
                </Checkbox>
              </VStack>
            </AlertDialogBody>

            <AlertDialogFooter>
              <ChakraButton variant={'ghost'} ref={cancelRef} onClick={donwloadOnClose}>
                Cancelar
              </ChakraButton>
              <ChakraButton
                colorScheme="green"
                isDisabled={!agreed}
                onClick={() => {
                  if (!book) return;
                  donwloadOnClose();
                  downloadBook.mutate(book.id);
                }}
                ml={3}
                isLoading={downloadBook.isLoading}
              >
                Baixar
              </ChakraButton>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <Modal isCentered size={{ base: 'xs', sm: 'sm', md: 'md' }} isOpen={book != null} onClose={closeBook}>
        <ModalOverlay backdropFilter={'blur(10px)'} />
        <ModalContent borderRadius={'20px'}>
          <ModalBody>
            <VStack spacing={5} paddingTop={'30px'} paddingBottom={'10px'}>
              <HStack position={'relative'} w={'100%'} align={'center'} justify={'center'}>
                <Image alignSelf={'center'} w={'50%'} aspectRatio={0.7} objectFit={'cover'} src={book?.cover} />

                <VStack right={0} pos={'absolute'}>
                  {canDowload && (
                    <Tooltip label="Enviar por email">
                      <Center
                        onClick={() => book && !sendBookAsEmailMutation.isLoading && onOpen()}
                        cursor={'pointer'}
                        padding="10px"
                        border={'1px solid black'}
                        borderRadius={'100%'}
                      >
                        <FaEnvelope />
                      </Center>
                    </Tooltip>
                  )}
                  {book?.isExchangeable && (
                    <Tooltip label="Trocar por outro livro">
                      <Center
                        onClick={() => navigateTo(`/recebidos/${book.id}/troca`)}
                        cursor={'pointer'}
                        padding="10px"
                        border={'1px solid black'}
                        borderRadius={'100%'}
                      >
                        <FaArrowRotateRight />
                      </Center>
                    </Tooltip>
                  )}
                  <Tooltip label="Favoritar">
                    <Center
                      onClick={() =>
                        book?.id && (favorite ? unfavoriteBook.mutate(book?.id) : favoriteBook.mutate(book?.id))
                      }
                      cursor={'pointer'}
                      padding="10px"
                      border={`1px solid ${favorite ? 'red' : 'black'}`}
                      borderRadius={'100%'}
                    >
                      {getBookMutation.isLoading || favoriteBook.isLoading || unfavoriteBook.isLoading ? (
                        <CircularProgress size={4} color="black" isIndeterminate />
                      ) : (
                        <FaHeart color={favorite ? 'red' : 'black'} />
                      )}
                    </Center>
                  </Tooltip>
                  {canDowload && (
                    <Tooltip label="Fazer Download">
                      <Center
                        onClick={() => downloadOnOpen()}
                        cursor={'pointer'}
                        padding="10px"
                        border={'1px solid black'}
                        borderRadius={'100%'}
                      >
                        {getBookMutation.isLoading || downloadBook.isLoading ? (
                          <CircularProgress size={4} color="black" isIndeterminate />
                        ) : (
                          <FaDownload />
                        )}
                      </Center>
                    </Tooltip>
                  )}
                </VStack>
              </HStack>

              <VStack spacing={0}>
                <SectionTitle color="black" textAlign={'center'}>
                  {book?.title}
                </SectionTitle>
                {book?.author && (
                  <Text fontSize={'14px'} color={'#a9a9a9'}>
                    {book?.author}
                  </Text>
                )}
              </VStack>
              <Box
                width={'100%'}
                style={{
                  maxHeight: isNative ? '130px' : '250px',
                  overflowY: 'auto',
                  borderBottom: '1px solid #dedede',
                }}
                dangerouslySetInnerHTML={{ __html: book?.description || '' }}
              />
              <HStack w={'100%'}>
                <ChakraButton
                  onClick={closeBook}
                  width={'100%'}
                  borderRadius="100px"
                  padding="23px 0px"
                  isLoading={getBookMutation.isLoading}
                  alignSelf={'flex-end'}
                  backgroundColor={'white'}
                  border="2px solid black"
                  color="black"
                  _hover={{ backgroundColor: 'whiteAlpha.600' }}
                >
                  Fechar
                </ChakraButton>
                <ChakraButton
                  width={'100%'}
                  borderRadius="100px"
                  color="white"
                  _hover={{ backgroundColor: colors.primaryColor }}
                  padding="23px 0px"
                  border={`2px solid ${colors.primaryColor}`}
                  backgroundColor={colors.primaryColor}
                  onClick={() => {
                    isAudioBook
                      ? uraModuleCellphone
                        ? (window.location.href = `tel:${uraModuleCellphone?.replace(/\s/g, '')}`)
                        : openAudio.onOpen()
                      : book?.id && getBookMutation.mutate(book?.id);
                  }}
                  isLoading={getBookMutation.isLoading}
                  alignSelf={'flex-end'}
                  rightIcon={<LuMoveRight fontSize={'24px'} />}
                >
                  {isAudioBook ? 'Ouvir' : 'Ler'}
                </ChakraButton>
              </HStack>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>
      <AudioBookPlayer openAudio={openAudio} audiobooks={book?.audiobooks || []} />
    </>
  );
}
